import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2fb7798b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-nowrap items-center gap-2" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-xl text-900 font-bold" }, "Active Faces", -1));
const _hoisted_3 = { class: "flex flex-nowrap items-center gap-2" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-xl text-900 font-bold" }, "Assigned Faces", -1));
import { onMounted, ref, computed, watch } from 'vue';
import { useFetch } from '@apparatix/composables';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { useToast } from 'primevue/usetoast';
import { FilterMatchMode } from 'primevue/api';
import FormSkeleton from '@apparatix/Components/FormSkeleton.vue';
import MultiSelect from 'primevue/multiselect';
import Button from 'primevue/button';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PricingRateCodeAssignment',
    props: {
        yieldCode: {},
        assignedSet: {},
        unassignedSet: {}
    },
    setup(__props) {
        const filtersAssigned = ref({
            inv_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
            inv_market: { value: null, matchMode: FilterMatchMode.IN },
            inv_type: { value: null, matchMode: FilterMatchMode.IN },
            name: { value: null, matchMode: FilterMatchMode.IN },
        });
        const filtersUnassigned = ref({
            inv_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
            inv_market: { value: null, matchMode: FilterMatchMode.IN },
            inv_type: { value: null, matchMode: FilterMatchMode.IN },
            name: { value: null, matchMode: FilterMatchMode.IN },
        });
        const props = __props;
        const { get } = useFetch();
        const toast = useToast();
        const isLoading = ref(false);
        const faces = ref([{}]);
        const filteredAssigned = ref([]);
        const filteredUnassigned = ref([]);
        const selectedAssign = ref();
        const selectedUnassign = ref();
        watch(selectedAssign, (newValue) => {
            if (!newValue.length) {
                return;
            }
            newValue.forEach((selectedFace) => {
                const index = faces.value.findIndex(face => face.inv_number === selectedFace.inv_number);
                if (props.unassignedSet.has(faces.value[index].inv_id)) {
                    props.unassignedSet.delete(faces.value[index].inv_id);
                }
                else {
                    props.assignedSet.add(faces.value[index].inv_id);
                }
                faces.value[index].inv_ratecode = props.yieldCode.id;
            });
            selectedAssign.value = [];
        });
        watch(selectedUnassign, (newValue) => {
            if (!newValue.length) {
                return;
            }
            newValue.forEach((selectedFace) => {
                const index = faces.value.findIndex(face => face.inv_number === selectedFace.inv_number);
                if (props.assignedSet.has(faces.value[index].inv_id)) {
                    props.assignedSet.delete(faces.value[index].inv_id);
                }
                else {
                    props.unassignedSet.add(faces.value[index].inv_id);
                }
                faces.value[index].inv_ratecode = 'Unassigned';
            });
            selectedUnassign.value = [];
        });
        const markets = computed(() => {
            const markets = faces.value.map(face => face['inv_market']);
            return [...new Set(markets)];
        });
        const types = computed(() => {
            const invTypes = faces.value.map(face => face['inv_type']);
            return [...new Set(invTypes)];
        });
        const yieldCodes = computed(() => {
            const yieldCodes = faces.value.map(face => face['name']);
            const set = new Set(yieldCodes);
            const yieldCodeMapping = [];
            set.forEach(code => {
                if (!code) {
                    yieldCodeMapping.push({ name: 'Unassigned', code: null });
                }
                else {
                    yieldCodeMapping.push({ name: code, code: code });
                }
            });
            return yieldCodeMapping;
        });
        const assignedCodes = computed(() => faces.value.filter(face => face.inv_ratecode == props.yieldCode.id));
        const unassignedCodes = computed(() => faces.value.filter(face => face.inv_ratecode != props.yieldCode.id));
        const loadData = async () => {
            isLoading.value = true;
            const data = await get('/pricingAssignCodes');
            if (data?.error) {
                toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong loading faces', life: 3000 });
                return;
            }
            isLoading.value = false;
            faces.value = data.faceList;
        };
        const onAssignClick = (face) => { selectedAssign.value = [face]; };
        const onAssignAllClick = () => { selectedAssign.value = filteredUnassigned.value; };
        const onFilterAssigned = (e) => {
            filteredAssigned.value = e.filteredValue;
        };
        const onUnassignClick = (face) => { selectedUnassign.value = [face]; };
        const onUnassignAllClick = () => { selectedUnassign.value = filteredAssigned.value; };
        const onFilterUnassigned = (e) => {
            filteredUnassigned.value = e.filteredValue;
        };
        onMounted(() => loadData());
        return (_ctx, _cache) => {
            const _component_pv_badge = _resolveComponent("pv-badge");
            const _component_InputText = _resolveComponent("InputText");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (isLoading.value)
                    ? (_openBlock(), _createBlock(FormSkeleton, { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(DataTable), {
                        key: 1,
                        filters: filtersUnassigned.value,
                        "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((filtersUnassigned).value = $event)),
                        selection: selectedAssign.value,
                        "onUpdate:selection": _cache[2] || (_cache[2] = ($event) => ((selectedAssign).value = $event)),
                        value: unassignedCodes.value,
                        size: "small",
                        "data-key": "inv_id",
                        "filter-display": "row",
                        "striped-rows": "",
                        paginator: "",
                        rows: 5,
                        "rows-per-page-options": [5, 10, 25, 100, 500, 1000, 5000],
                        "table-style": "min-width: 50rem;",
                        "removable-sort": "",
                        onFilter: onFilterUnassigned
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _hoisted_2,
                                _createVNode(_component_pv_badge, {
                                    value: filteredUnassigned.value.length,
                                    severity: "secondary"
                                }, null, 8, ["value"])
                            ])
                        ]),
                        empty: _withCtx(() => [
                            _createTextVNode(" No Faces found. ")
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                                field: "inv_number",
                                header: "Face",
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_component_InputText, {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        type: "text",
                                        class: "p-column-filter",
                                        placeholder: "Faces",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        onInput: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                field: "inv_market",
                                header: "Market",
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_unref(MultiSelect), {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        options: markets.value,
                                        filter: "",
                                        placeholder: "Markets",
                                        class: "p-column-filter",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        "show-clear": true,
                                        onChange: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                field: "inv_type",
                                header: "Type",
                                "show-filter-menu": false,
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_unref(MultiSelect), {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        options: types.value,
                                        placeholder: "Types",
                                        class: "p-column-filter",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        "show-clear": true,
                                        onChange: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                field: "name",
                                header: "Yield Code",
                                "show-filter-menu": false,
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_unref(MultiSelect), {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        options: yieldCodes.value,
                                        "option-label": "name",
                                        "option-value": "code",
                                        placeholder: "Codes",
                                        class: "p-column-filter",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        "show-clear": true,
                                        onChange: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                "header-style": "min-width: 3rem; max-width: 3rem",
                                "show-filter-menu": false
                            }, {
                                filter: _withCtx(({}) => [
                                    _withDirectives(_createVNode(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        rounded: "",
                                        outlined: "",
                                        label: "Add All",
                                        style: { "width": "max-content", "font-weight": "400" },
                                        onClick: _cache[0] || (_cache[0] = ($event) => (onAssignAllClick()))
                                    }, null, 512), [
                                        [
                                            _directive_tooltip,
                                            'Add Filtered Faces',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                body: _withCtx((slotProps) => [
                                    _createVNode(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        rounded: "",
                                        outlined: "",
                                        label: "Add",
                                        style: { "height": "25px", "font-weight": "400" },
                                        onClick: ($event) => (onAssignClick(slotProps.data))
                                    }, null, 8, ["onClick"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["filters", "selection", "value"])),
                (isLoading.value)
                    ? (_openBlock(), _createBlock(FormSkeleton, { key: 2 }))
                    : (_openBlock(), _createBlock(_unref(DataTable), {
                        key: 3,
                        filters: filtersAssigned.value,
                        "onUpdate:filters": _cache[4] || (_cache[4] = ($event) => ((filtersAssigned).value = $event)),
                        selection: selectedUnassign.value,
                        "onUpdate:selection": _cache[5] || (_cache[5] = ($event) => ((selectedUnassign).value = $event)),
                        value: assignedCodes.value,
                        size: "small",
                        "data-key": "inv_id",
                        "filter-display": "row",
                        "striped-rows": "",
                        paginator: "",
                        rows: 5,
                        "rows-per-page-options": [5, 10, 25, 100, 500, 1000, 5000],
                        "table-style": "min-width: 50rem",
                        "removable-sort": "",
                        onFilter: onFilterAssigned
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _hoisted_4,
                                _createVNode(_component_pv_badge, {
                                    value: filteredAssigned.value.length,
                                    severity: "secondary"
                                }, null, 8, ["value"])
                            ])
                        ]),
                        empty: _withCtx(() => [
                            _createTextVNode(" No Faces found. ")
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                                field: "inv_number",
                                header: "Face",
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_component_InputText, {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        type: "text",
                                        class: "p-column-filter",
                                        placeholder: "Faces",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        onInput: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                field: "inv_market",
                                header: "Market",
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_unref(MultiSelect), {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        options: markets.value,
                                        filter: "",
                                        placeholder: "Markets",
                                        class: "p-column-filter",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        "show-clear": true,
                                        onChange: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                field: "inv_type",
                                header: "Type",
                                "show-filter-menu": false,
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_unref(MultiSelect), {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        options: types.value,
                                        placeholder: "Types",
                                        class: "p-column-filter",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        "show-clear": true,
                                        onChange: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                field: "name",
                                header: "Yield Code",
                                "show-filter-menu": false,
                                sortable: ""
                            }, {
                                filter: _withCtx(({ filterModel, filterCallback }) => [
                                    _createVNode(_unref(MultiSelect), {
                                        modelValue: filterModel.value,
                                        "onUpdate:modelValue": ($event) => ((filterModel.value) = $event),
                                        options: yieldCodes.value,
                                        "option-label": "name",
                                        "option-value": "code",
                                        placeholder: "Codes",
                                        class: "p-column-filter",
                                        style: { "min-width": "8rem", "max-width": "8rem" },
                                        "show-clear": true,
                                        onChange: ($event) => (filterCallback())
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), {
                                "header-style": "min-width: 3rem; max-width: 3rem",
                                "show-filter-menu": false
                            }, {
                                filter: _withCtx(({}) => [
                                    _withDirectives(_createVNode(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        rounded: "",
                                        outlined: "",
                                        label: "Remove All",
                                        style: { "width": "max-content", "font-weight": "400" },
                                        onClick: _cache[3] || (_cache[3] = ($event) => (onUnassignAllClick()))
                                    }, null, 512), [
                                        [
                                            _directive_tooltip,
                                            'Remove Filtered Faces',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                body: _withCtx((slotProps) => [
                                    _createVNode(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        rounded: "",
                                        outlined: "",
                                        label: "Remove",
                                        style: { "height": "25px", "font-weight": "400" },
                                        onClick: ($event) => (onUnassignClick(slotProps.data))
                                    }, null, 8, ["onClick"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["filters", "selection", "value"]))
            ], 64));
        };
    }
});
